import { INcsScoresReport } from './ncs-scores-report';

export interface INcsScoresReportTotals extends INcsScoresReport {
    // ctrAlias: string;
    // centerState: string;
    // grandclCu: number;
    // grandWlpOffers: number;
    // grandWlpDeclines: number;
    // grandDeclineRatio: number;
    // grandchains12: number;
    // grandOldChains12: number;
    // grandchains24: number;
    // granddeclines12: number;
    // grandoChains24: number;
    // grandofvChains24: number;
    // grandnonofvChains24: number;
    // grandfvCume: number;
    // grandoChainsRatio24: number;
    // grandDeclineRatio12: number;
    // grandOldDeclineRatio12: number;
    // grandofvChainsRatio24: number;
    // grandadpStarts: number;
    // grandnddStarts: number;
    // grandfcstADPStarts: number;
    // grandfcstNDDStarts: number;
    // grandadpEnds: number;
    // grandnddEnds: number;
    // grandfcstADPEnds: number;
    // grandfcstNDDEnds: number;
    // grandtotalStarts: number;
    // grandtotalEnds: number;
    // grandnddncSa: number;
    // grandadpncSa: number;
    // grandSummaryncSa: number;
    // grandDetailsncSa: number;
    // grandncSb: number;
    // grandncSu: number;
    // grandncsDeficit: number;
    // grandfcstTotalStarts: number;
    // grandfcstTotalEnds: number;
    // grandfcstNDDNCS: number;
    // grandfcstADPNCS: number;
    // grandPartner: number;
    // grandofvTarget: number;
    // grandStarts: number;
    // grandEnds: number;
    // grandfcstNCS: number;
    // grandnfvTarget: number;
    partnerCenterCount: number,
    memberCenterCount: number,
    anyAnatomyCount: number,
    // anyAnatomyZeroDeclineBonusCount: number
    // grandcsfvStartersLast12: number;
    // grandcssvStartersLast12: number;
    // grandcsCompPairsLast12: number;
    // grandCompScore: number;
    // grandShareOfCompScore: number;
    // grandShareOfFloat: number;
    // grandTargetChainEnds: number;
}